import { render } from "./SkillBar.vue?vue&type=template&id=ed45b186&scoped=true"
import script from "./SkillBar.vue?vue&type=script&lang=js"
export * from "./SkillBar.vue?vue&type=script&lang=js"

import "./SkillBar.vue?vue&type=style&index=0&id=ed45b186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed45b186"]])

export default __exports__